import clsx from 'clsx'
import { Loader } from '@/components/Loader'
import { ButtonBase } from '../ButtonBase'
import { IButtonProps } from '../types'
import styles from './styles.module.scss'

const ButtonDestructive = ({ children, className, isLoading, ...props }: IButtonProps) => {
  return (
    <ButtonBase
      data-testid="mui-button-destructive"
      className={clsx(styles.destructive, className)}
      isLoading={isLoading}
      {...props}
    >
      {isLoading && <Loader className={styles.loader} />}
      {children}
    </ButtonBase>
  )
}

export default ButtonDestructive
